import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useUrlSearchParams } from 'use-url-search-params';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import { bulkOrderDetail } from '../../actions/orderActions';
import { SORTING_ORDER } from '../../../../constants/index';
import FilterSearch from '../../../../components/FilterSearch/FilterSearch';
import DHPagination from '../../../../components/Pagination';
import BulkOrderEditOffcanvas from './BulkOrderEditOffcanvas';
import AiBadgeIcon from './AiBadgeIcon';

import moment from 'moment';

import {
  Table,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardHeader,
  Spinner,
} from 'reactstrap';
//import {useIntl} from 'react-intl';
import CountUp from 'react-countup';

const BulkOrderList = () => {
  const location = useLocation();

  const dispatch = useDispatch();
  //const { formatMessage: f } = useIntl();
  //const [countryCode, setCountryCode] = useUrlSearchParams({ country: "" });

  const [sortingName, setSortingName] = useState({ id: 'sort.date_asc' });
  const [paginationValue, setPaginationValue] = useUrlSearchParams({ page: 0 });
  const [limitValue, setLimitValue] = useUrlSearchParams({ limit: 10 });
  const [sortingValue, setSortingValue] = useUrlSearchParams({
    sort: '_date',
    order: SORTING_ORDER.ASC,
  });
  const urlParams = new URLSearchParams(location.search);
  const [searchFilter, setSearchFilter] = useState({
    search: urlParams.get('search') || '',
  });
  const [statusFilter, setStatusFilter] = useState({
    status: urlParams.get('status') || 'All',
  });
  const [advancedFilter, setAdvancedFilter] = useState({});
  const [orderMode, setOrderMode] = useState('All');
  let is_split = 0;
  const { country = [] } = useSelector((state) => state.country);

  const splitVal = location?.pathname.split('/');

  const [isDataLoading, setDataLoading] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [selectedBulkId, setSelectedBulkId] = useState(null);

  const toggleEditOffcanvas = () => setEditOpen((prev) => !prev);
  const handleEdit = (bulkId) => {
    setSelectedBulkId(bulkId);
    setEditOpen(true);
  };

  const fetchBulkOrders = () => {
    setDataLoading(true);
    bulkOrderDetail({
      params: {
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
        search_qry: searchFilter?.search,
        status: statusFilter?.status,
        country: localStorage.getItem('WEBSITE_COUNTRY'),
        orderBy: 'id',
        advancedFilter,
      },
      dispatch,
    });
    setDataLoading(false);
  };

  useEffect(() => {
    fetchBulkOrders();
  }, [
    paginationValue.page,
    limitValue,
    sortingValue.sort,
    searchFilter,
    statusFilter,
    advancedFilter,
  ]);

  const { bulkOrders = [], isBulkLoading } = useSelector(
    (state) => state.order
  );

  const { listOrders } = bulkOrders;
  const orderData = listOrders?.orderList;

  let LsSts = 'New';

  const sortByValues = [
    { key: 'date', order: SORTING_ORDER.ASC, label: { id: 'sort.date_asc' } },
    { key: 'date', order: SORTING_ORDER.DESC, label: { id: 'sort.date_desc' } },
    {
      key: 'status',
      order: SORTING_ORDER.ASC,
      label: { id: 'sort.status_asc' },
    },
    {
      key: 'status',
      order: SORTING_ORDER.DESC,
      label: { id: 'sort.status_desc' },
    },
  ];

  const handleSorting = (type, order = SORTING_ORDER.ASC, name) => {
    setSortingValue({ sort: type, order });
    setSortingName(name);
  };

  let pageIndex = Number(listOrders?.start);

  return (
    <>
      <FilterSearch
        filterType="bulkOrder"
        setSearchFilter={setSearchFilter}
        setStatusFilter={setStatusFilter}
        setAdvancedFilter={setAdvancedFilter}
      />

      <div className="table-responsive dt-table">
        {isBulkLoading || isDataLoading ? (
          <Spinner className="ms-2 sploader" color="primary" />
        ) : null}
        {orderData?.length > 0 ? (
          <>
            <Table className="OrderListTable table mb-0">
              <thead>
                <tr>
                  <th>SI.No</th>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Source</th>
                  <th>SKU</th>
                  <th>Qty</th>
                  <th nowrap="nowrap">Company Name</th>
                  <th>Remarks</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              {(orderData || []).map((order, index) => {
                pageIndex++;

                //  console.log("order_id----------",order_id);
                let cdate = order.Date,
                  orderDt = moment(new Date(cdate)).format('Do MMM, YYYY'),
                  orderTime = moment(new Date(cdate)).format('h:mm:ss a');

                let stsBtn = 'bg-soft-dark text-dark';
                if (order.Status === '0') {
                  stsBtn = 'bg-soft-warning text-dark';
                  LsSts = 'Pending';
                } else {
                  stsBtn = 'bg-success';
                  LsSts = 'Completed';
                }

                const isBulk = Number(order.Qty) > 3;

                return (
                  <tbody key={order.BulkId}>
                    <tr className={isBulk ? 'table-warning' : ''}>
                      <th scope="row">{pageIndex}</th>
                      <td nowrap="nowrap">
                        {orderDt} <br></br>
                        {orderTime}
                      </td>
                      <td>
                        <div>{order.FullName}</div>
                        <div className="text-muted small">{order.MobileNumber}</div>
                        <div className="text-muted small">{order.Email}</div>
                      </td>
                      <td>
                        {Number(order.IsYara) === 1 ? (
                          <span
                            className="d-inline-flex align-items-center gap-1 border rounded-pill px-2 py-1 text-muted"
                            style={{ fontSize: 12 }}
                            title="Generated via Yara AI Chat Assistant"
                          >
                            by Yara <AiBadgeIcon size={18} />
                          </span>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td>{order.Sku}</td>
                      <td nowrap="nowrap">
                        {order.Qty}
                        {isBulk ? (
                          <Badge className="bg-danger ms-1">Bulk order</Badge>
                        ) : null}
                      </td>
                      <td nowrap="nowrap">{order.Company}</td>
                      <td>
                        <div
                          style={{
                            maxWidth: 220,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {order.Remarks}
                        </div>
                      </td>
                      <td>
                        <Badge className={` ${stsBtn}`}>{LsSts}</Badge>
                      </td>
                      <td>
                        <span
                          role="button"
                          onClick={() => handleEdit(order.BulkId)}
                          className="btn btn-sm btn-outline-warning waves-effect waves-light"
                        >
                          {' '}
                          <i className="mdi mdi-border-color"></i>{' '}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                );
              })}
            </Table>

            <DHPagination
              totalPages={listOrders?.recordsTotal}
              currentPage={paginationValue.page}
              setPaginationValue={setPaginationValue}
              setLimitValue={setLimitValue}
            />
          </>
        ) : (
          <>
            <Table className="OrderListTable table mb-0">
              <thead>
                <tr>
                  <th>SI.No</th>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Source</th>
                  <th>SKU</th>
                  <th>Qty</th>
                  <th>Company Name</th>
                  <th>Remarks</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={9}>No Records found</td>
                </tr>
              </tbody>
            </Table>
          </>
        )}
      </div>

      <BulkOrderEditOffcanvas
        isOpen={editOpen}
        toggle={toggleEditOffcanvas}
        bulkId={selectedBulkId}
        onSaved={fetchBulkOrders}
      />
    </>
  );
};
export default BulkOrderList;
